// This file is auto-generated by @skynet/data-helpers/scripts/generate-rtk-exports.mjs
// Do not edit manually.

import { hookExports } from './dex-agent-api';

export const useChatAgent: typeof hookExports.useChatAgent = hookExports.useChatAgent;
